import { render, staticRenderFns } from "./sglNews.vue?vue&type=template&id=4dbb94c2&scoped=true&"
import script from "./sglNews.vue?vue&type=script&lang=js&"
export * from "./sglNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb94c2",
  null
  
)

export default component.exports